var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumberListIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon list number",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.478 32.728a.746.746 0 0 1 .762-.688h1.016a.709.709 0 0 1 .762.688v3.438h.508a.691.691 0 1 1 0 1.376h-2.54a.691.691 0 1 1 0-1.376h.508v-2.75h-.254a.746.746 0 0 1-.762-.688zM42.5 40.9a.521.521 0 0 0-.763.034l-.353.444a.816.816 0 0 1-1.063.16.644.644 0 0 1-.177-.957l.353-.447a2.146 2.146 0 0 1 3.15-.14 1.69 1.69 0 0 1-.035 2.428L42.5 43.5h1.054a.691.691 0 1 1 0 1.376H40.76a.766.766 0 0 1-.7-.413.637.637 0 0 1 .138-.742l2.287-2.236a.411.411 0 0 0 .01-.588zm12.486-7.945a.922.922 0 1 1 0 1.834h-8.13a.922.922 0 1 1 0-1.834zm0 4.586a.922.922 0 1 1 0 1.834h-8.13a.922.922 0 1 1 0-1.834zm0 4.586a.922.922 0 1 1 0 1.834h-8.13a.922.922 0 1 1 0-1.834z",
    fill: "currentColor",
    transform: "translate(-39.998 -31.237)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberListIcon);
export default __webpack_public_path__ + "static/media/number-list-icon.f9456b9d701f73e3006e488ac1c9717c.svg";
export { ForwardRef as ReactComponent };